export default __webpack_public_path__ + "static/media/oficina.ba25a791.svg";